import * as React from "react";
const SvgIcSubstract = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 7, width: 14, height: 2, rx: 1, fill: "#000", fillRule: "evenodd" }));
export default SvgIcSubstract;
